"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function (m, exports) {
    for (var p in m)
        if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p))
            __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeFormListItem = void 0;
var attribute_form_list_item_component_1 = require("./attribute-form-list-item.component");
Object.defineProperty(exports, "AttributeFormListItem", { enumerable: true, get: function () { return attribute_form_list_item_component_1.AttributeFormListItem; } });
__exportStar(require("./add-button"), exports);
__exportStar(require("./form-list-manager"), exports);
